import React, { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { getResult } from '../api'
import { useData } from '../contexts/DataContext'

const ShareRedirect = ({setResult, setNavIndex, setShareId}) => {
    const params = useParams()
    const [loaded, setLoad] = useState(false)
    const { updateSuggestion } = useData();
    useEffect(()=>{

       setShareId(params.id)
       setNavIndex(9)
       setLoad(true)
       updateSuggestion(true)
    }, [])
    return !loaded ? <>Loading...</> : <Navigate to='/' />

}

export default ShareRedirect